import {FormControl} from '@angular/forms';

export function passwordFormatValidator(control: FormControl) {

  let valid = true;
  let isSpace = false;

  if (control.value) {
    Object.values(control.value).forEach(l => {
      if (l === ' ') {
        isSpace = true;
      }
    });
  }

  if (control.value.replace(/[0-9]/g, '') === ''
      || control.value.replace(/[a-zA-Z]/g, '') === ''
      || control.value.length < 6
      || isSpace
      || control.value.replace(/[^A-Z]/g, '') === ''
      || control.value.replace(/[^a-z]/g, '') === ''
     ) {
      valid = false;
  }

  return valid ? null : {invalidFormat: !valid};
}
